import { SynerallProduct } from '@vae/server/src/modules/ExternalAPIs/Synerall/synerallTypes'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import StringInput from '../../../components/inputs/StringInput'
import { AppContext } from '../../../contexts/AppContext'
import i18n from '../../../i18n'

const ProductDetailsStep: React.FC<{ product: SynerallProduct | null | undefined }> = ({
	product,
}) => {
	const { isDarkMode } = useContext(AppContext)

	const productName = product?.Titles.find((x: any) => x.Lang.toLowerCase() === i18n.language)
	const monthlyPrice = product?.Prices.find((x: any) => x.PriceType === 'Monthly')
	const marginPrice = product?.Prices.find((x: any) => x.PriceType === 'Margin')
	const fixedPrice = product?.Prices.find((x: any) => x.PriceType === 'Base')
	const contractTerm = product?.ContractTerm.find(
		(x: any) => x.Lang.toLowerCase() === i18n.language
	)
	const monthsWithoutMonthlyPayment = product?.NumberOfMonthsToSkipFirstMonthlyFee

	const { t } = useTranslation('modals_createContract', { keyPrefix: 'productDetailsStep' })

	const disabledColor = isDarkMode ? '#ffffff' : '#000000'

	return (
		<div className='container'>
			{productName && (
				<StringInput
					readonly
					value={productName.Value}
					label={t('product')}
					variant='standard'
					multiline
					disabledColor={disabledColor}
				/>
			)}
			{monthlyPrice && (
				<StringInput
					readonly
					value={`${monthlyPrice?.UnitWithVatInEur}/${monthlyPrice?.Unit}`}
					label={t('basicFee')}
					variant='standard'
					disabledColor={disabledColor}
				/>
			)}
			{marginPrice && (
				<StringInput
					readonly
					value={`${marginPrice?.UnitWithVatInEur}/${marginPrice?.Unit} ${t('spot')}`}
					label={t('margin')}
					variant='standard'
					disabledColor={disabledColor}
				/>
			)}
			{fixedPrice && (
				<StringInput
					readonly
					value={`${fixedPrice?.UnitWithVatInEur}/${fixedPrice?.Unit}`}
					label={t('electricityFee')}
					variant='standard'
					disabledColor={disabledColor}
				/>
			)}
			{monthsWithoutMonthlyPayment && (
				<StringInput
					readonly
					value={`${monthsWithoutMonthlyPayment}`}
					label={t('freeMonths')}
					variant='standard'
					disabledColor={disabledColor}
				/>
			)}
			{contractTerm && (
				<StringInput
					readonly
					value={contractTerm.Value}
					label={t('contractType')}
					variant='standard'
					disabledColor={disabledColor}
				/>
			)}
		</div>
	)
}

export default ProductDetailsStep
